var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c("div", { staticClass: "modal-wrap" }, [
      _c("div", { staticClass: "dialog-header" }, [
        _c("div", { staticClass: "dialog-title" }, [
          _vm._v("Deactivate Account"),
        ]),
        _c(
          "div",
          { staticClass: "close-btn", on: { click: _vm.closeDialog } },
          [
            _c("img", {
              attrs: { src: "/img/onboarding/cancel_close.svg", alt: "" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "dialog-footer" }, [
        _c(
          "button",
          {
            staticClass: "grupa-red-btn",
            staticStyle: { "margin-right": "24px" },
            on: { click: _vm.closeDialog },
          },
          [_vm._v("\n        No, Go back\n      ")]
        ),
        _c(
          "button",
          { staticClass: "grupa-grey-btn", on: { click: _vm.handleDelete } },
          [
            _vm._v("\n        Yes, Proceed\n        "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.spinner,
                  expression: "spinner",
                },
              ],
              staticClass: "button-spinner",
              staticStyle: { "margin-left": "20px" },
              attrs: { src: "/img/lightbox/preloader.gif" },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialog-content" }, [
      _c("div", { staticClass: "delete-item-msg" }, [
        _vm._v(
          "\n        You are about to deactivate your account, this will prevent you from\n        accessing your Grupa account\n      "
        ),
      ]),
      _c("div", { staticClass: "delete-item-prompt" }, [
        _vm._v("Do you wish to continue?"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }